import React from "react";
import AccidentDescriptions from "./AccidentDescriptions";
import AccidentSummary from "./AccidentSummary";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);

export const accidentDescription = (data) => {
	let contributing_sentence = "";

	data.vehicles.forEach((v) => {
		if (
			v.contributing_factor1 &&
			v.contributing_factor1 !== "NONE" &&
			v.contributing_factor1 !== "N"
		) {
			let veh = "";
			if (v.vehicle_color) veh = veh + v.vehicle_color.toLowerCase() + " ";
			if (v.vehicle_maker) veh = veh + v.vehicle_maker;
			if (v.vehicle_model_year) veh = veh + " (" + v.vehicle_model_year + ")";
			contributing_sentence = `The driver of ${veh} ${v.contributing_factor1.toLowerCase()}.`;
		}

		if (
			v.contributing_factor2 &&
			v.contributing_factor2 !== "NONE" &&
			v.contributing_factor2 !== "N"
		) {
			let veh = "";
			if (v.vehicle_color) veh = veh + v.vehicle_color.toLowerCase() + " ";
			if (v.vehicle_maker) veh = veh + v.vehicle_maker;
			if (v.vehicle_model_year) veh = veh + " (" + v.vehicle_model_year + ")";
			contributing_sentence = `The driver of ${veh} ${v.contributing_factor2.toLowerCase()}.`;
		}
	});

	return `This accident${
		data.vehicles
			? data.vehicles.length > 1
				? `, involving ${data.vehicles.length} vehicles`
				: `, involving ${data.vehicles.length} vehicle`
			: ""
	}
    occurred on ${dayjs(data.date).format("dddd, MMMM Do YYYY")} at
		approximately ${dayjs(data.date).format("h:mm a")}.
		${contributing_sentence}
    ${
			data.total_injury_count > 0
				? "Injuries were reported."
				: "There were no injuries, to either drivers or passengers reported."
		} ${
		data.weather_conditions
			? AccidentDescriptions[data.weather_conditions]
				? AccidentDescriptions[data.weather_conditions].text
				: ""
			: ""
	} An officer from ${data.agency}
                  was present at the scene and recorded the information
                  contained in this report.`;
};

export const accidentSummary = (data) => {
	return (
		<ul className="summary">
			{data.vehicles ? (
				data.vehicles.length > 1 ? (
					<li>{data.vehicles.length} vehicles involved</li>
				) : (
					<li>{data.vehicles.length} vehicle involved</li>
				)
			) : null}
			<li>
				Occurred on {dayjs(data.date).format("dddd, MMMM Do YYYY")} at
				approximately {dayjs(data.date).format("h:mm a")}.
			</li>
			<li>
				{data.total_injury_count > 0 ? "Injuries were reported" : "No injuries"}
				.
			</li>
			{data.weather_conditions && AccidentSummary[data.weather_conditions] ? (
				<li>{AccidentSummary[data.weather_conditions].text}</li>
			) : null}
			<li>An officer from {data.agency} was present</li>
		</ul>
	);
};

export const accidentContributingFactors = (vehicle, index) => {
	let data = "";

	if (Object.keys(vehicle).length) {
		if (vehicle.contributing_factor1) {
			if (vehicle.contributing_factor2) {
				if (vehicle.contributing_factor3) {
					data = (
						<ul key={index}>
							<li>
								{`The driver of ${vehicle.vehicle_model_year || ""} ${
									vehicle.vehicle_maker === "UNKNOWN"
										? "UNKNOWN VEHICLE"
										: vehicle.vehicle_maker
								} ${vehicle.contributing_factor1}`}
							</li>
							<li>
								{`The driver of ${vehicle.vehicle_model_year || ""} ${
									vehicle.vehicle_maker === "UNKNOWN"
										? "UNKNOWN VEHICLE"
										: vehicle.vehicle_maker
								} ${vehicle.contributing_factor2}`}
							</li>
							<li>
								{`The driver of ${vehicle.vehicle_model_year || ""} ${
									vehicle.vehicle_maker === "UNKNOWN"
										? "UNKNOWN VEHICLE"
										: vehicle.vehicle_maker
								} ${vehicle.contributing_factor3}`}
							</li>
						</ul>
					);
				} else {
					data = (
						<ul key={index}>
							<li>
								{`The driver of ${vehicle.vehicle_model_year || ""} ${
									vehicle.vehicle_maker === "UNKNOWN"
										? "UNKNOWN VEHICLE"
										: vehicle.vehicle_maker
								} ${vehicle.contributing_factor1}`}
							</li>
							<li>
								{`The driver of ${vehicle.vehicle_model_year || ""} ${
									vehicle.vehicle_maker === "UNKNOWN"
										? "UNKNOWN VEHICLE"
										: vehicle.vehicle_maker
								} ${vehicle.contributing_factor2}`}
							</li>
						</ul>
					);
				}
			} else {
				data = (
					<ul key={index}>
						{vehicle.contributing_factor1 !== "NONE" ? (
							<li>
								The driver of {vehicle.vehicle_model_year || ""}{" "}
								{vehicle.vehicle_maker === "UNKNOWN"
									? "UNKNOWN VEHICLE"
									: vehicle.vehicle_maker}{" "}
								{vehicle.contributing_factor1}
							</li>
						) : null}
					</ul>
				);
			}
		}
	} else {
		return "";
	}

	return data;
};

export const findGuilty = (accident) => {
	let faults = [];
	if (accident && accident.vehicles) {
		accident.vehicles.forEach((v) => {
			const insurance_unknown = [
				"",
				"**UNKNOWN",
				"n/a",
				"na",
				"unconfirmed",
				"unk",
				"unknown",
				"unknown ",
				"unknown evaded",
				"Unk",
				"Unknown",
				"Unknown ",
				"Unknown - Evaded",
				"Unknown Evaded",
				"Unknown/Evaded",
				"Unknwon",
				"Unkonwn",
				"Unkown",
				"UNKNOWN",
				"N\\A",
				"NONE OR UNKNOWN",
				"NO KNOWN"
			];

			const insurance_none = [
				"                                 NONE",
				"-NONE PROVIDED-",
				"NOT INSURED",
				"no insurance",
				"none",
				"NO INS",
				"NO INSURANCE",
				"NO INSURANCE ",
				"NO INSURANCE PARKED VEHICLE",
				"NO PROOF",
				"NO PROOF OF INSURANCE",
				"NO PROOF OF INSURANCE OBTAINED",
				"NONE",
				"NONE ",
				"NONE FOUND",
				"NONE FOUND OR PROVIDED",
				"NONE GIVEN",
				"NONE IN VEHICLE",
				"NONE LOCATED",
				"NONE ON REGISTRATION",
				"NONE PROVIDED"
			];

			let insurance = " (Insured)";
			insurance_unknown.forEach((item) => {
				if (item == v.insurance) {
					insurance = " (Insurance unknown)";
				}
			});

			insurance_none.forEach((item) => {
				if (item == v.insurance) {
					insurance = " (Not Insured)";
				}
			});

			if (!v.insurance) {
				insurance = " (Insurance unknown)";
			}

			if (
				v.contributing_factor1 &&
				v.contributing_factor1 !== "NONE" &&
				v.contributing_factor1 !== "N"
			) {
				let f = v.vehicle_maker ? v.vehicle_maker : "Unknown";
				f = f + (v.vehicle_model_year ? " - " + v.vehicle_model_year : "");
				f = f + (v.vehicle_color ? ", " + v.vehicle_color : "");
				if (accident.state !== "IL") {
					f = f + insurance;
				}
				faults.push(f);
				// if (
				// 	accident.state === "TX" &&
				// 	v.vehicle_model_year &&
				// 	v.vehicle_color &&
				// 	v.vehicle_maker
				// ) {
				// 	faults.push(
				// 		`${v.vehicle_model_year}, ${v.vehicle_color} ${v.vehicle_maker} ${
				// 			accident.state !== "IL"
				// 				? v.insurance && v.insurance !== "NONE"
				// 					? "(Insured)"
				// 					: "(Non Insured)"
				// 				: ""
				// 		}`
				// 	);
				// } else if (
				// 	!accident.state === "TX" &&
				// 	v.vehicle_model_year &&
				// 	v.vehicle_maker
				// ) {
				// 	console.log("HERE");
				// 	faults.push(
				// 		`${v.vehicle_model_year}, ${v.vehicle_maker} ${
				// 			accident.state !== "IL"
				// 				? v.insurance && v.insurance !== "NONE"
				// 					? "(Insured)"
				// 					: "(Non Insured)"
				// 				: ""
				// 		}`
				// 	);
			}
			// else faults.push("(Unknown)");
			// }
		});
	}
	if (faults.length === 1) return faults[0];
	if (faults.length > 1) return "MULTIPLE";
	return "NOT SPECIFIED";
};

export const chooseImage = (vehicle) => {
	// console.log(vehicle);
	const { participants, vehicle_maker } = vehicle;
	if (participants[0] && participants[0].type === "PEDESTRIAN") {
		return "pedestrian";
	} else if (
		vehicle_maker === "FREIGHTLINER" ||
		vehicle_maker === "HINO" ||
		vehicle_maker === "INTERNATIONAL" ||
		vehicle_maker === "KENTUCKY MFG" ||
		vehicle_maker === "KENWORTH" ||
		vehicle_maker === "MACK" ||
		vehicle_maker === "MCCLAIN INDUSTRIES" ||
		vehicle_maker === "PETERBILT" ||
		vehicle_maker === "SPARTAN MOTORS" ||
		vehicle_maker === "THOMAS" ||
		vehicle_maker === "UNITED EXPRESS LINE INC" ||
		vehicle_maker === "UTILITY TRAILER MFG" ||
		vehicle_maker === "WESTERN STAR/AUTO CAR" ||
		vehicle_maker === "WHITE/GMC"
	) {
		return "truck";
	} else if (
		vehicle_maker === "CHANCE COACH TRANSIT BUS" ||
		vehicle_maker === "IC CORPORATION" ||
		vehicle_maker === "LES AUTOBUS MCI" ||
		vehicle_maker === "NEW FLYER" ||
		vehicle_maker === "NORTH AMERICAN BUS INDUSTRIES (NABI)" ||
		vehicle_maker === "NOVA BUS CORPORATION" ||
		vehicle_maker === "TOMSA" ||
		vehicle_maker === "VAN HOOL" ||
		vehicle_maker === "BLUE BIRD"
	) {
		return "bus";
	} else if (
		vehicle_maker === "MOTOR COACH INDUSTRIES" ||
		vehicle_maker === "PREVOST"
	) {
		return "rv";
	} else if (vehicle_maker === "POLARIS") {
		return "atv";
	} else if (
		participants[0] &&
		participants[0].type &&
		participants[0].type.indexOf("MOTORCYCLE") > -1
	) {
		return "motorcycle";
	} else {
		return "car";
	}
};
